__turbopack_context__.v({
  "blocksBackgroundColor": "HeaderShortcuts-module-scss-module__yLEiZa__blocksBackgroundColor",
  "blocksFontColor": "HeaderShortcuts-module-scss-module__yLEiZa__blocksFontColor",
  "container": "HeaderShortcuts-module-scss-module__yLEiZa__container",
  "dragSource": "HeaderShortcuts-module-scss-module__yLEiZa__dragSource",
  "draggable": "HeaderShortcuts-module-scss-module__yLEiZa__draggable",
  "editControls": "HeaderShortcuts-module-scss-module__yLEiZa__editControls",
  "editorTile": "HeaderShortcuts-module-scss-module__yLEiZa__editorTile",
  "glyph": "HeaderShortcuts-module-scss-module__yLEiZa__glyph",
  "label": "HeaderShortcuts-module-scss-module__yLEiZa__label",
  "link": "HeaderShortcuts-module-scss-module__yLEiZa__link",
  "reorder": "HeaderShortcuts-module-scss-module__yLEiZa__reorder",
  "secondaryNavBackgroundColor": "HeaderShortcuts-module-scss-module__yLEiZa__secondaryNavBackgroundColor",
  "themeBackgroundColor": "HeaderShortcuts-module-scss-module__yLEiZa__themeBackgroundColor",
  "themeFontColor": "HeaderShortcuts-module-scss-module__yLEiZa__themeFontColor",
  "tile": "HeaderShortcuts-module-scss-module__yLEiZa__tile",
});
